import { DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postAccidentForm } from "../../../../actions/accidents";
import { getFormEmployeeOptions, getFormEmployers } from "../../../../actions/forms";
import CustomDialog from "../../../commons/dialog/customDialog";
import CircularLoading from "../../../commons/loadingData/circularLoading";
import { StyledEditAccidentFormContainer } from "../../../styled/accident";
import EditAccidentForm from "./editAccidentForm";

const EditAccidentFormContainer = ({
  open,
  artId,
  handleCloseForm,
  handleSubmitForm,
  facadeAccident,
}) => {
  const dispatch = useDispatch();
  const isFromValidator = Boolean(facadeAccident?.isFromValidator);

  const accidentFormState = useSelector((state) => state.accidents.form);
  const postFormState = useSelector((state) => state.accidents.postForm);
  const diagnosis = useSelector((state) => state.forms.diagnosis);

  const [accidentForm, setAccidentForm] = useState(null);
  const [accidentModel, setAccidentModel] = useState(null);
  const [firstLoad, setFirstLoad] = useState(true);

  const isLoading =
    accidentFormState.isFetching ||
    diagnosis.isFetching ||
    !accidentForm ||
    !accidentModel ||
    postFormState.isFetching ||
    firstLoad;

  useEffect(() => {
    if (open) {

      Promise.all([
        dispatch(getFormEmployers(artId)),
        new Promise((resolve) => {
          if (facadeAccident && facadeAccident.cuitEmpleador) {
            return resolve(dispatch(getFormEmployeeOptions(artId, facadeAccident.cuitEmpleador)));
          }
          else return resolve();
        })
      ]).finally(() => {
        setFirstLoad(false);
      });
    } else {
      setFirstLoad(true);
    }
  }, [open])

  const handleOnEmployerChange = (employer) => {
    const cuit = employer.cuit || employer.cuitEmpleador;
    if (cuit) {
      dispatch(getFormEmployeeOptions(artId, cuit));
    }
  }

  useEffect(() => {
    if (!accidentFormState.isFetching && accidentFormState.data.model) {
      if (
        facadeAccident &&
        !accidentFormState.data.model.referenteApellidoyNombre.options.some(
          (r) => r.nombre === facadeAccident.referenteApellidoyNombre,
        )
      ) {
        accidentFormState.data.model.referenteApellidoyNombre.options.push({
          id: facadeAccident.idReferenteExterno,
          nombre: facadeAccident.referenteApellidoyNombre,
          email: facadeAccident.referenteEmail,
        });
      }
      setAccidentModel({
        nroSiniestroArt: accidentFormState.data.model.nroSiniestroArt,
        referenteApellidoyNombre: accidentFormState.data.model.referenteApellidoyNombre,
        diagnosticoOMS: accidentFormState.data.model.diagnosticoOMS,
        fechaHoraAccidente: accidentFormState.data.model.fechaHoraAccidente,
        cuilCuitTrabajador: accidentFormState.data.model.cuilCuitTrabajador,
        cuitEmpleador: accidentFormState.data.model.cuitEmpleador,
      });
    }
  }, [accidentFormState.isFetching]);

  useEffect(() => {
    if (
      !accidentFormState.isFetching &&
      (facadeAccident || accidentFormState.data.form)
    ) {
      const form = facadeAccident || accidentFormState.data.form;
      setAccidentForm({
        nroSiniestroArt: form.nroSiniestroArt || "",
        diagnosticoOMS: accidentFormState.data.diagnoticoOMSConverted || form.diagnosticoOMS,
        referenteApellidoyNombre: form.referenteApellidoyNombre,
        idReferenteExterno: form.idReferenteExterno,
        referenteEmail: form.referenteEmail,
        siniestro: form.siniestro,
        fechaHoraAccidente: form.fechaHoraAccidente,
        cuilCuitTrabajador: form.cuilCuitTrabajador,
        cuitEmpleador: form.cuitEmpleador,
        trabajador: form.cuilCuitTrabajador,
        empleador: form.cuitEmpleador,
      });
    }
  }, [accidentFormState.isFetching]);

  const handleSubmit = (form) => {
    setAccidentForm(null);
    setAccidentModel(null);
    dispatch(postAccidentForm(form, artId, facadeAccident.prestadorId))
      .then((res) => handleSubmitForm(res))
      .catch(() => handleClose());
  };

  const handleClose = () => {
    setAccidentForm(null);
    setAccidentModel(null);
    handleCloseForm();
  };

  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Editar Siniestro</DialogTitle>
      <StyledEditAccidentFormContainer.Container>
        {isLoading ? (
          <StyledEditAccidentFormContainer.CircularLoadingContainer>
            <CircularLoading />
          </StyledEditAccidentFormContainer.CircularLoadingContainer>
        ) : (
          <EditAccidentForm
            model={accidentModel}
            accident={accidentForm}
            artId={artId}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            fromFacade={isFromValidator}
            onEmployerChange={handleOnEmployerChange}
          />
        )}
      </StyledEditAccidentFormContainer.Container>
    </CustomDialog>
  );
};

export default EditAccidentFormContainer;
